import defaultState from './defaultState'

const unwrapState = state => state.toast || defaultState

export const getToast = state => unwrapState(state)
